import React from 'react';
import { useIntl } from 'react-intl';
import { shallowEqual } from 'react-redux';

import facebookImage from '../../assets/VS_Facebook.jpg';
import twitterImage from '../../assets/VS_Twitter.jpg';
import BottomNavigationBar from '../../components/Layouts/BottomNavigationBar/BottomNavigationBar';
import Footer from '../../components/Layouts/Footer/Footer';
import LayoutSingleColumn from '../../components/Layouts/LayoutSingleColumn';
import LayoutWrapperBottombar from '../../components/Layouts/LayoutWrapperBottombar/LayoutWrapperBottombar';
import LayoutWrapperFooter from '../../components/Layouts/LayoutWrapperFooter/LayoutWrapperFooter';
import LayoutWrapperMain from '../../components/Layouts/LayoutWrapperMain';
import LayoutWrapperTopbar from '../../components/Layouts/LayoutWrapperTopbar/LayoutWrapperTopbar';
import TopBar from '../../components/Layouts/TopBar/TopBar';
import Page from '../../components/Page/Page';
import config from '../../config';
import useAppSelector from '../../util/hooks/useAppSelector';
import { isCordova } from '../../util/mobile/deviceDetection';
import SectionCities from './SectionCities';
import SectionCountries from './SectionCountries';
import SectionDestinations from './SectionDestinations';
import SectionHero from './SectionHero';
import SectionLandingResults from './SectionLandingResults';
import SectionPassTiers from './SectionPassTiers';
import SectionRegions from './SectionRegions';
import SectionWhyVanSite from './SectionWhyVanSite';

export const LandingPage = () => {
  const intl = useIntl();

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'LandingPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  // Retrieve products from Redux store
  const { products, productsLoading, productsError } = useAppSelector(
    (state) => ({
      products: state.LandingPage.products,
      productsLoading: state.LandingPage.productsLoading,
      productsError: state.LandingPage.productsError,
    }),
    shallowEqual,
  );

  const showPassTiers = ['de', 'en', 'fr', 'it'].includes(intl.locale) && !productsError;

  const landingPageContent = (
    <>
      <SectionHero />

      {showPassTiers ? <SectionPassTiers loading={productsLoading} products={products} /> : null}

      {!isCordova() ? <SectionLandingResults /> : null}

      {intl.locale === 'de' ? (
        <>
          <SectionDestinations />
          <SectionCountries />
          <SectionRegions />
          <SectionCities />
          {!isCordova() ? <SectionWhyVanSite /> : null}
        </>
      ) : null}
    </>
  );

  return (
    <Page
      contentType="website"
      description={schemaDescription}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      keywords={[intl.formatMessage({ id: 'LandingPage.keyword' })]}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
      title={schemaTitle}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopBar currentPage="LandingPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>{landingPageContent}</LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
        <LayoutWrapperBottombar>
          <BottomNavigationBar />
        </LayoutWrapperBottombar>
      </LayoutSingleColumn>
    </Page>
  );
};

export default LandingPage;
